import React, { Component } from 'react';
import ImageHelper from '../../helpers/ImageHelper';
import Banner from './Banner';
import ItemIntro from './ItemIntro';
import Rating from './Rating';

export default class ItemWithPhoto extends Component {
  render() {
    let { uploadedImages, menu, _location, itemQuantity } = this.props;

    const placeholder = ImageHelper.getImageURL(menu.menu_photo, '?func=crop&w=300&h=300');
    let grid_layout = localStorage.getItem('grid_layout');
    return (
      <React.Fragment>
        <Banner
          goBack={this.props.goBack}
          images={uploadedImages}
          key="banner"
          placeholder={placeholder}
        />
        <div className="item-rating rating-bg" key="rating">
          <Rating grid_layout={grid_layout} item={menu} settings={this.props.locationSettings} />
        </div>
        <div className="item-int d-lg-none d-md-block d-sm-block">
          <ItemIntro
            itemQuantity={itemQuantity}
            goBack={this.props.goBack}
            menu={menu}
            location={_location}
            key="intro"
            originalPrice={this.props.originalPrice}
            discountedPrice={this.props.discountedPrice}
          />
        </div>
      </React.Fragment>
    );
  }
}
